// @ts-check
import BlockCard from '../BlockCard';

/** One horizontal bar per SEO check, scaled to the largest count; an all-clear message when nothing is outstanding. */
export default function SeoBlock({ block }) {
  const checks = block.data?.checks || [];
  const max = Math.max(0, ...checks.map((c) => c.count));

  return (
    <BlockCard title="SEO" href={block.href} headline={block.headline}>
      {max === 0 ? (
        <p className="text-sm text-muted-foreground">No SEO issues found</p>
      ) : (
        <ul className="space-y-2">
          {checks.map((c) => (
            <li key={c.key} data-testid="seo-check" className="text-sm">
              <div className="flex items-center justify-between">
                <span>{c.label}</span>
                <span className="font-medium">{c.count}</span>
              </div>
              <div className="mt-1 h-2 rounded bg-muted">
                <div data-testid="seo-bar" className="h-2 rounded bg-primary" style={{ width: `${(c.count / max) * 100}%` }} />
              </div>
            </li>
          ))}
        </ul>
      )}
    </BlockCard>
  );
}
